const announcement = document.querySelector<HTMLElement>("[data-announcement]");
const dismissButton = announcement?.querySelector<HTMLButtonElement>(
  "[data-announcement-dismiss]",
);
const storageKey = announcement?.dataset.announcementStorageKey;

function wasDismissed(key: string): boolean {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function rememberDismissal(key: string): void {
  try {
    localStorage.setItem(key, "1");
  } catch {
    // The banner can still be dismissed for the current page view.
  }
}

if (announcement && storageKey && wasDismissed(storageKey)) {
  announcement.hidden = true;
}

dismissButton?.addEventListener("click", () => {
  if (!announcement) return;

  if (storageKey) rememberDismissal(storageKey);
  announcement.hidden = true;

  document
    .querySelector<HTMLElement>("[data-site-header] nav a, [data-site-header] nav button")
    ?.focus();
});
